<i18n>
    {
        "ru": {
            "headline": "Купить",
            "disabledMessage": "Для покупки необходимо принять условия правил"
        },
        "en": {
            "headline": "Buy",
            "disabledMessage": "Для покупки необходимо принять условия правил"
        }
    }
</i18n>

<template>
    <button :class="$style.button" :disabled="disabled">
        <CircularButtonLoader v-if="loading" />
        <!-- <span v-else-if="unagreement">{{ $t("disabledMessage") }}</span> -->
        <span v-else>{{ $t("headline") }}</span>
    </button>
</template>

<script>
import CircularButtonLoader from "./CircularButtonLoader";

export default {
    name: "BuyButton",
    components: {
        CircularButtonLoader,
    },
    props: {
        disabled: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        unagreement: { type: Boolean, default: false },
    },
};
</script>

<style module>
.button {
    border: none;
    width: 100%;
    font-family: inherit;
    font-size: 18px;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    border-radius: 4px;
}

.button:not(:disabled) {
    cursor: pointer;
    background-color: rgb(65, 65, 255);
    color: rgb(255, 255, 255);
}

.button:disabled {
    background-color: #eee;
}

.button:disabled > div {
    border: 2px solid rgb(185, 185, 185);
    border-radius: 50%;
    border-top: 2px solid rgb(65, 65, 255);
    width: 18px;
    height: 18px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
